import { Component, OnInit, ViewChildren, QueryList, ViewChild, EventEmitter, Output } from '@angular/core';
import { BasicInfo, Guest, ContactInfo, Waiver, GuestBase } from 'src/app/models/waiver';
import { GuestBasicinfoEditComponent } from '../guest-basicinfo-edit/guest-basicinfo-edit.component';
import { StoreService } from 'src/app/services/store.service';
import { WaiverService } from 'src/app/services/waiver.service';
import { WaiverSteps, CustomFieldType } from 'src/app/alv-enums';
import { NgForm } from '@angular/forms';
import { GuestContactinfoEditComponent } from '../guest-contactinfo-edit/guest-contactinfo-edit.component';
import { ToolsService } from 'src/app/services/tools.service';
import { optionValue, CustomFields } from 'src/app/models/custom-fields';
import { Utility } from 'src/app/common/utility';

@Component({
  selector: 'add-guests',
  templateUrl: './add-guests.component.html',
  styleUrls: ['./add-guests.component.scss']
})
export class AddGuestsComponent implements OnInit {
  @ViewChildren(GuestBasicinfoEditComponent) basicInfoChildren: QueryList<GuestBasicinfoEditComponent>
  @ViewChild(GuestContactinfoEditComponent) bcontactInfo: GuestContactinfoEditComponent
  @ViewChild("myForm") myForm: NgForm;
  constructor(protected storeService: StoreService, protected waiverService: WaiverService, protected toolsService: ToolsService) { }
  waiver: Waiver;
  test: string;
  firstName: string;
  formSubmitted: boolean = false;
  isValid:boolean = true;
  get birthDayErrorMessage(): string {

    if (this.waiver && this.waiver.signee && this.waiver.signee.basicInfo && this.waiver.signee.basicInfo.firstName)
      return `${this.waiver.signee.basicInfo.firstName} must be at least ${this.minAgeOfConsent} years old`;
  }

  //weed out guests who have guest Id since they are existing guests and not to be edited
  get selectedGuests(): GuestBase[] {
    return this.waiver.guests.filter(g => g.selected == true && g.exists == false)
  }

  get minAgeOfConsent(): string {
    return (this.waiver && +(this.waiver.minAgeOfConsent) > 0 ? this.waiver.minAgeOfConsent : '18');
  }
  ngOnInit() {
    const self = this;
    this.waiver = new Waiver();
    this.waiver.guests =  Object.assign([], this.storeService.waiver.guests);
    this.waiver.signee = Object.assign({}, this.storeService.waiver.signee);
    !this.waiver.guests && (this.waiver.guests = []);
    !this.waiver.signee && (this.waiver.signee = new Guest())

    //get Custom Fields
    self.waiverService.getSignWaiver(this.storeService.waiver.waiverId)
      .then(response => {
        this.toolsService.ProcessHttpResponse(response, () => {
          if (response.succeeded) {
            let waiverData = response.data;
            let currentWaiver = this.storeService.waiver;
            if (waiverData.waiverCommonFormFieldList) {
              let waiverFields = waiverData.waiverCommonFormFieldList.filter(f => f.isPerWavier)
                .sort((a, b) => a.ord - b.ord)
              if (!this.waiver.waiverCustomFields || this.waiver.waiverCustomFields.length < 1) {
                this.waiver.waiverCustomFields = this.buildCustomFields(waiverFields);
              }
              let guestFields = waiverData.waiverCommonFormFieldList.filter(f => f.isPerGuest)
                .sort((a, b) => a.ord - b.ord)
              if (!this.waiver.guestCustomFields || this.waiver.guestCustomFields.length < 1)
                this.waiver.guestCustomFields = this.buildCustomFields(guestFields);
              if (!this.waiver.signee.customFields || this.waiver.signee.customFields.length < 1) {
                this.waiver.signee.customFields = this.addGuestCustomFields(this.waiver.signee.guestId, this.waiver.guestCustomFields);
                this.waiver.guests.forEach(guest => {
                  guest.customFields = this.addGuestCustomFields(guest.guestId, this.waiver.guestCustomFields);
                })
              }
            }

          }
        })
      })

  }

  addGuestCustomFields(guestId: number, guestCustomFields: CustomFields[]): CustomFields[] {
    //clone guest custom field cor current guest
    guestCustomFields = guestCustomFields.map(x => Object.assign({}, x));
    guestCustomFields.forEach(customField => {
      customField.guestId = guestId;
    });
    guestCustomFields.forEach(customField=>{
if(this.waiver.signee && customField.fieldName == "Street Address"){
  customField.fieldValue = this.waiver.signee.contactInfo.streetAddress
}
if(this.waiver.signee && customField.fieldName == "City"){
  customField.fieldValue = this.waiver.signee.contactInfo.city
}
if(this.waiver.signee && customField.fieldName == "State"){
  customField.fieldValue = this.waiver.signee.contactInfo.state
}
if(this.waiver.signee && customField.fieldName == "Zip Code"){
  customField.fieldValue = this.waiver.signee.contactInfo.zipCode
}

    });
    return guestCustomFields;
  }

  addMinor() {
    let guest = new GuestBase()
    guest.selected = true;
    guest.exists = false;
    guest.basicInfo = new BasicInfo();
    guest.basicInfo.birthDate = new Date();
    guest.basicInfo.IsMinor = true;
    //guest.customFields = this.addGuestCustomFields(guest.guestId, this.waiver.guestCustomFields);
    this.waiver.guests.push(guest);
  }
  addAdult() {
    let guest = new GuestBase()
    guest.selected = true;
    guest.exists = false;
    guest.basicInfo = new BasicInfo();
    guest.basicInfo.birthDate = new Date();
    guest.basicInfo.IsMinor = false;
    //guest.customFields = this.addGuestCustomFields(guest.guestId, this.waiver.guestCustomFields);
    this.waiver.guests.push(guest);
  }
  removeGuest(display: string) {
    this.waiver.guests.splice(this.waiver.guests.findIndex(f => f.basicInfo.displayInfo == display))
  }

  setFormSubmitted() {
    this.basicInfoChildren.forEach(basicinfo => {
      basicinfo.formSubmitted = true;
      basicinfo.customFieldControls.forEach(contactInfo => {
        contactInfo.formSubmitted = true;
      })
    });
    this.bcontactInfo.formSubmitted = true;
    this.bcontactInfo.customFieldControls.forEach(contactInfo => {
      contactInfo.formSubmitted = true;
    })
    return this.validateForm();
  }

  validateForm(): boolean {
    this.isValid =true;
    if (this.waiver && this.waiver.signee && this.waiver.signee.basicInfo) {
      let info = this.waiver.signee.basicInfo;
      let bDay = new Date(info.bYear, info.bMonth, info.bDate);
      let age = Utility.calculateAge(bDay)
      if (age < +(this.minAgeOfConsent)) {
        this.isValid = false;
      }
    }
    return this.isValid;
  }

  getMinorCount(index: number) {
    let noOfAdults = 0;
    //index - no of adults to left of the array
    for (var i = 0; i < index; i++) {
      if (this.selectedGuests[i].basicInfo.IsMinor == false) {
        noOfAdults++;
      }
    }
    return index - noOfAdults;
  }

  getAdultCount(index: number) {
    let noOfMinors = 0;
    //index - no of minors to left of the array
    for (var i = 0; i < index; i++) {
      if (this.selectedGuests[i].basicInfo.IsMinor == true) {
        noOfMinors++;
      }
    }
    return index - noOfMinors;
  }

  getLabel(guest: Guest, index: number) {
    return guest.basicInfo && guest.basicInfo.IsMinor ? 'Minor ' + (this.getMinorCount(index) + 1).toString()
      : 'Adult ' + (this.getAdultCount(index) + 1).toString();
  }
  onSubmit() {
    let s = this.myForm.valid;
    this.waiver.signee.guestAccountOwner = true;
    this.goToStep(WaiverSteps.signWaiver)
    window.scroll(0,0)
  }
  goToStep(step: WaiverSteps) {
    const self = this;
    this.storeService.waiver.guests = this.waiver.guests;
    this.storeService.waiver.waiverCustomFields = this.waiver.waiverCustomFields;
    //go to next step guest selection
    self.waiverService.onStepChangeForward(step);
  }
  closeKeyboard(event: any) {
  }

  private buildCustomFields(waiverFields: any) {
    let fields: CustomFields[] = [];
    waiverFields.forEach(element => {
      let customField = new CustomFields();
      customField.fieldId = element.fieldId;
      customField.waiverffId = element.waiverffId;
      customField.fieldName = element.fieldName;
      customField.customFieldType = element.format;
      customField.isRequired = element.isRequired;
      //if dropdown field
      if (customField && customField.customFieldType == CustomFieldType.dropdown && element.cmnFrmFld && element.cmnFrmFld.formFieldDetail) {
        customField.options = [];
        let options = element.cmnFrmFld.formFieldDetail.filter(f => f.isActive && !f.isDeleted);
        options.forEach(element => {
          let option = new optionValue();
          option.id = element.fieldDetailId;
          option.text = element.fieldText;
          customField.options.push(option);
        });
      }
      if(this.waiver.signee && customField.fieldName == "Street Address"){
        customField.fieldValue = this.waiver.signee.contactInfo.streetAddress
      }
      if(this.waiver.signee && customField.fieldName == "City"){
        customField.fieldValue = this.waiver.signee.contactInfo.city
      }
      if(this.waiver.signee && customField.fieldName == "State"){
        customField.fieldValue = this.waiver.signee.contactInfo.state
      }
      if(this.waiver.signee && customField.fieldName == "Zip Code"){
        customField.fieldValue = this.waiver.signee.contactInfo.zipCode
      }
      fields.push(customField);
    });
    return fields;
  }
}
